import { render, staticRenderFns } from "./SubNav2.vue?vue&type=template&id=484caa84&scoped=true"
import script from "./SubNav2.vue?vue&type=script&lang=ts"
export * from "./SubNav2.vue?vue&type=script&lang=ts"
import style0 from "./SubNav2.vue?vue&type=style&index=0&id=484caa84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484caa84",
  null
  
)

export default component.exports